import Button from '@components/Button';
import LocationIcon from '@components/Map/LocationIcon';
import styled from '@emotion/styled';
import useProject from '@hooks/useProject';
import useScript from '@hooks/useScript';
import { useId, useRef, useState } from 'react';
import Skeleton from 'react-loading-skeleton';

import { MapProps } from '../types';
import useMap from './hooks/useMap';
import useMarkers from './hooks/useMarkers';

function InaviMap({
    center, zoom = 13, width = '100%', markers, onMarkerClick, height, onBoundChange,
    showMyLocation,
}:MapProps) {
    const id = useId();
    const mapRef = useRef<inavi.maps.Map>(null);
    const [isMapLoad, setIsMapLoad] = useState<boolean>(false);
    useMap({
        mapRef, setIsMapLoad, isMapLoad, zoom, center, id, onBoundChange, showMyLocation,
    });
    useMarkers({
        mapRef, markers, isMapLoad, onMarkerClick,
    });
    const reCenterMap = () => {
        mapRef.current?.setCenter({ lat: center.lat, lng: center.lng });
    };
    const project = useProject();

    useScript({
        src: `https://imaps.inavi.com/maps/v3.0/appkeys/${project?.mapApiKey}/maps?callback=initMap`,
        enabled: !!project?.mapApiKey,
    });

    return (
        <Wrapper>
            <Container style={{ height, minHeight: height, maxHeight: height }}>
                <div id={id} style={{
                    width,
                    height,
                    minHeight: height,
                    maxHeight: height,
                }}/>
                {(!isMapLoad) && (
                    <SkeletonWrapper >
                        <Skeleton width='100%' height='100%' count={1}/>
                    </SkeletonWrapper>
                )}
            </Container>
            {showMyLocation && (
                <LocationButton size='sm'
                    onClick={reCenterMap} >
                    <LocationIcon/>
                    내 위치 확인
                </LocationButton>
            )}
        </Wrapper>
    );
}

const Wrapper = styled.div`
    align-items: center;
    display: flex;
    flex-direction: column;
    position: relative;
    width: 100%;
`;

const Container = styled.div`
    position: relative;
    width: 100%;
`;

const SkeletonWrapper = styled.div`
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    position: absolute;
    background-color: rgba(0, 0, 0, 0.3);
    z-index: 2;
`;

const LocationButton = styled(Button)`
    border-radius: 15px;
    bottom: 12px;
    box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.25);
    column-gap: 2px;
    display: flex;
    height: 36px !important;
    padding: 6px 12px !important;
    position: absolute !important;
    z-index: 2;
`;

export default InaviMap;
